export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11585.f5fd80a6.jpg";